const getNumberOptionsSelected = (options = []) => {
  return options.filter((filteredOption) => filteredOption.selected).length;
};

export default getNumberOptionsSelected;
